export default "__VITE_ASSET__yHYOhGgL__"